import React from 'react'
import './projects.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation} from 'swiper';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import view1 from '../../assets/Dashboard.png';
import view2 from '../../assets/dashboard2.png';
import view3 from '../../assets/django.png';
import view4 from '../../assets/usman.png';
import view5 from '../../assets/priceCompare.png';


const data = [
  {
    avatar: view2, 
    name: 'AIEMS Dashboard',
    review: 'veryg asdfasdfasdfa'
  },
  {
    avatar: view1, 
    name: 'AIEMS Dashboard',
    review: 'veryg asdfasdfasdfa'
  },
  {
    avatar: view3, 
    name: 'Air Smart Energy Dashboard',
    review: 'Noice'
  },
  {
    avatar: view4, 
    name: 'Usman Awan Portfolio',
    review: 'veryg asdfasdfasdfa'
  },
  {
    avatar: view5, 
    name: 'Price Compare Scraping Site',
    review: 'veryg asdfasdfasdfa'
  },
  
]
const Testimonials = () => {
  return (
    <section id='projects'>
      <h5>Some of my Projects</h5>
      <h2>Projects</h2>
      <div className="container testimonials__container">
      <Swiper
        // install Swiper modules
        modules={[Pagination, Navigation]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
        navigation
      >
        {data.map(({avatar,name,review},index)=>{
          return(
              <SwiperSlide key={index} className="testimonial">
                
                  <img src={avatar} alt="Avatar one" />
                
                <h5 className="client__name">{name}</h5>
                  <small className="client__review">
                  {review}
                  </small>
              </SwiperSlide>
          );
        })
        }
      </Swiper>
        
        
      </div>
    </section>
  )
}

export default Testimonials